module.exports = __webpack_public_path__ + "static/media/Hydraulics_Body-Cropped.fea77800.gif";